import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getEventDetail, getSectionsDetailKeywordVer1 } from '../../api/home'
import { getFilterFestivalList } from '../../api/product'
import { BtnHomeModuleMore } from '../../components/Button'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductModal from '../../components/product/ProductModal'
import { FestivalItem } from './FestivalItem'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../../components/provider/AppProvider'

function FestivalHorizontal({ el, isMobile }: any): JSX.Element {
  const [swiper, setSwiper] = useState<any>()
  const [eventItem, setEventItem] = useState<any>([])
  const [productNo, setProductNo] = useState<number | undefined>()
  const [likeItem, setLikeItem] = useState(false)
  const [horizontalType, setHorizontalType] = useState<string>('')
  const [hoModal, setHoModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState()
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  const params = useParams()

  const handlePrev = () => {
    swiper?.slidePrev()
  }
  const handleNext = () => {
    swiper?.slideNext()
  }

  const onClickMore = () => {
    const collection = el.shopbyFestivalComponentCollections[0]
    let url = ''

    if (horizontalType === 'section') {
      url = `${process.env.REACT_APP_SHOP_URL}/festivalsection?path=${params.url}&sectionNo=${collection.no}&mobileImage=${el.mobileImageUrl}&pcImage=${el.pcImageUrl}`
    } else if (horizontalType === 'category' || horizontalType === 'exhibition') {
      url = `${process.env.REACT_APP_SHOP_URL}${collection.path}`
    }

    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
      })
    } else {
      if (horizontalType === 'section') {
        navigate(`/festivalsection`, {
          state: {
            path: params.url,
            sectionNo: collection.no,
            mobileImage: el.mobileImageUrl,
            pcImage: el.pcImageUrl,
          },
        })
      } else {
        navigate(collection.path)
      }
    }
  }

  useEffect(() => {
    if (el) {
      setProductNo(el.shopbyFestivalComponentCollections[0].no)
      setHorizontalType(el.shopbyFestivalComponentCollections[0].type)
    }
  }, [el])

  useEffect(() => {
    if (productNo) {
      const fetchData = async () => {
        try {
          if (horizontalType === 'category') {
            const res = await getFilterFestivalList(productNo)
            setEventItem(res.data.items)
          } else if (horizontalType === 'section') {
            const { data } = await getSectionsDetailKeywordVer1(productNo, 'ADMIN_SETTING')
            setEventItem(data.products)
          } else if (horizontalType === 'exhibition') {
            const res = await getEventDetail(productNo, 'ADMIN_SETTING')
            setEventItem(res.data.section[0].products)
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      }

      setTimeout(fetchData, 200)
    }
  }, [productNo, horizontalType])

  return (
    <>
      <div className='swiper_header_img'>
        <img src={isMobile ? el.mobileImageUrl : el.pcImageUrl} alt='' />
      </div>
      {/* swiper */}

      <div className='swiper_wrap home_wrap'>
        <Swiper
          onSwiper={(e: any) => {
            setSwiper(e)
          }}
          slidesPerView={2.5}
          spaceBetween={8}
          modules={[Pagination]}
          breakpoints={{
            768: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
          }}
        >
          {/* 상품 불러오기 */}
          {eventItem !== null &&
            eventItem?.map((element: any, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <FestivalItem
                    el={element}
                    setIsModal={setHoModal}
                    setLike={setLikeItem}
                    setSelectProductNo={setSelectProductNo}
                  ></FestivalItem>
                </SwiperSlide>
              )
            })}
        </Swiper>
        {eventItem?.length < 5 ? null : (
          <React.Fragment>
            <button onClick={handlePrev} className='btnPrev' />
            <button onClick={handleNext} className='btnNext' />
          </React.Fragment>
        )}
      </div>

      {el.hasMoreButton && (
        <div className='btn_area'>
          <BtnHomeModuleMore onClick={onClickMore}>더보기</BtnHomeModuleMore>
        </div>
      )}

      {hoModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setHoModal}
            listItem={eventItem}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setHoModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={eventItem}
          ></ProductCenterModal>
        )
      ) : null}
      {/* {manyModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setManyModal}
            listItem={categoryItem}
            list={listItems}
            content={'123'}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setManyModal}
            content={'123'}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={categoryItem}
          ></ProductCenterModal>
        )
      ) : null} */}
    </>
  )
}

export default FestivalHorizontal
